module.exports = __webpack_public_path__ + "img/logo-lg--colored.9a32f7bb.png";